import Body from './Body';

const View = () => {
  return (
    <div>
      <Body />
    </div>
  );
};

export default View;
